module.exports = __webpack_public_path__ + "img/中国地产.381ab16b.png";